// AI选股
import strategyList from '@/views/ai_stock/index.vue' // 策略 list
import strategy from '@/views/ai_stock/strategy/index.vue' // 策略 详情

const routes = [
    {
        path: '/strategyList',
        name: 'strategyList',
        component: strategyList,
        meta: {
            title: '益学堂-AI策略',
        },
    },
    {
        path: '/strategy',
        name: 'strategy',
        component: strategy,
        meta: {
            title: '益学堂-AI策略',
        },
    },
]

export default routes;